import { useFragment } from '$contentful-gql/fragment-masking';
import { textFragment } from '$providers/common';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { IProductSlideItem, ProductSliderType } from './';

export function ProductSlideItem(
  props: IProductSlideItem & HTMLAttributes<HTMLElement>,
) {
  const { className, index, active, type, item, onClick } = props;

  const cardText = useFragment(textFragment, item);
  const typeClasses: Record<ProductSliderType, string> = {
    light: 'text-grey-100',
    dark: 'text-white',
  };

  return (
    <button
      key={index}
      className={cn(
        className,
        'py-2 transition-colors duration-300 style-heading-xxxs font-bold relative',
        active ? typeClasses[type] : 'text-grey-40',
      )}
      onClick={onClick}
    >
      {cardText.title}
    </button>
  );
}
